export const sq4d = {
  'images': [],
  'mainFeatures': [
    'Premium Nature Rubber with Nano Graphite Coating',
    'High Curved Windshield Available',
    'Patented Multifunctional Base Design'
  ],
  'material': [
    'Rubber: Premium Nature Rubber',
    'Steel: SK5',
    'Rivet: Steel Rivet',
    'Plastic: Spacer & Adapter: POM, Spoiler: PP+TPV',
  ],
  'featureIcons': ["11", "02", "03", "07"],
  'otherFeatures': ["01", "02"],
  'specification': [
    { "inch": "13", "mm": "336", "width": "6", "thickness": "0.8" },
    { "inch": "14", "mm": "356", "width": "6", "thickness": "0.8" },
    { "inch": "15", "mm": "386", "width": "6", "thickness": "0.8" },
    { "inch": "16", "mm": "406", "width": "6", "thickness": "0.8" },
    { "inch": "17", "mm": "436", "width": "6", "thickness": "0.8" },
    { "inch": "18", "mm": "456", "width": "6", "thickness": "0.8" },
    { "inch": "19", "mm": "486", "width": "6", "thickness": "0.8" },
    { "inch": "20", "mm": "506", "width": "6", "thickness": "0.8" },
    { "inch": "21", "mm": "536", "width": "6", "thickness": "0.8" },
    { "inch": "22", "mm": "566", "width": "6", "thickness": "0.8" },
    { "inch": "23", "mm": "586", "width": "6", "thickness": "0.8" },
    { "inch": "24", "mm": "606", "width": "6", "thickness": "0.9" },
    { "inch": "26", "mm": "656", "width": "6", "thickness": "0.9" },
    { "inch": "28", "mm": "706", "width": "6", "thickness": "0.9" }
  ],
  'adapters': [
    'b1', 'b6', 'bl-2a', 'cl+cl-r', "m3", 'm4', 'm5', 'ml', 'ph-3', 'pl', 'pt-3', 'pt6', 'pt-r', 'tl-2', 'tl4a', 'tlc'
  ]
}